import {
  AddManyParams,
  WixPatternsContainer,
  CollectionState,
  FiltersMap,
} from '@wix/bex-core';
import {
  ToolbarCollectionState,
  ToolbarCollectionStateParamsInitParams,
} from './ToolbarCollectionState';
import { GridState } from './GridState';
import { topGridSizePreset } from './gridSizePresets';

export interface CardsGridStateParams<T, F extends FiltersMap> {
  readonly collection: CollectionState<T, F>;
  readonly container: WixPatternsContainer;
  readonly toolbar?: ToolbarCollectionState<T, F>;
}

export interface CardsGridStateInitParams
  extends ToolbarCollectionStateParamsInitParams {}

export class CardsGridState<T, F extends FiltersMap> {
  readonly toolbar;
  readonly container;
  readonly collection;
  readonly grid;

  constructor(params: CardsGridStateParams<T, F>) {
    this.container = params.container;
    this.collection = params.collection;

    this.toolbar =
      params.toolbar ??
      new ToolbarCollectionState({
        collection: params.collection,
        container: params.container,
        componentType: 'Grid',
      });

    this.grid = new GridState({
      toolbar: this.toolbar as ToolbarCollectionState<unknown, Partial<F>>,
      collection: this.collection,
      container: this.container,
      sizePreset: topGridSizePreset,
    });
  }

  init(params: CardsGridStateInitParams) {
    const disposers = [this.toolbar.init(params)];

    return () => {
      for (const disposer of disposers) {
        disposer();
      }
    };
  }

  onAddItemActionComplete = async <R>(
    items: T[],
    params: AddManyParams<T, R> = {},
  ) => {
    return this.toolbar.onAddItemActionComplete(items, params);
  };
}
